import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "login" }
const _hoisted_2 = {
  class: "slide-up form-wrapper",
  style: {"padding":"0","width":"500px"}
}
const _hoisted_3 = { style: {"padding":"30px"} }
const _hoisted_4 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_5 = { style: {"margin-top":"10px"} }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  class: "error-msg-wrap"
}
const _hoisted_8 = { class: "error-msg" }
const _hoisted_9 = { style: {"margin-bottom":"15px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            placeholder: "Email",
            type: "email",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
          }, null, 512), [
            [_vModelText, _ctx.email]
          ]),
          _withDirectives(_createElementVNode("input", {
            placeholder: "Password",
            type: "password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
          }, null, 512), [
            [_vModelText, _ctx.password]
          ]),
          _createElementVNode("input", {
            style: {"margin-bottom":"20px"},
            value: "Log In",
            type: "submit",
            placeholder: "Submit",
            class: _normalizeClass(_ctx.submitted ? 'btn disable-button' : 'btn')
          }, null, 2),
          (_ctx.loginError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.loginErrorMessage), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", {
              onClick: _cache[2] || (_cache[2] = _withModifiers(() => { _ctx.showPasswordReset = true; }, ["prevent"])),
              style: {"text-decoration":"underline"}
            }, "Forgot your Password?")
          ])
        ], 32)
      ])
    ]),
    _createElementVNode("div", { innerHTML: _ctx.appHeightOverride }, null, 8, _hoisted_6),
    (_ctx.showPasswordReset)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { style: {"font-size":"24px"} }, "Enter the email for the account. If there is an account, you will receive an email with a link to reset your password.", -1)),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "email",
                placeholder: "Email",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.email) = $event))
              }, null, 512), [
                [_vModelText, _ctx.email]
              ])
            ]),
            _createElementVNode("div", {
              onClick: _cache[5] || (_cache[5] = () => { _ctx.showPasswordReset = false }),
              class: "btn-invert",
              style: {"margin-right":"10px"}
            }, "Cancel"),
            _createElementVNode("div", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submitPasswordReset())),
              class: "btn",
              style: {"margin-left":"10px"}
            }, "Submit")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}